import { render, staticRenderFns } from "./SucFileFieldComponent.vue?vue&type=template&id=4fde4a45&scoped=true&"
import script from "./SucFileFieldComponent.vue?vue&type=script&lang=js&"
export * from "./SucFileFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde4a45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fde4a45')) {
      api.createRecord('4fde4a45', component.options)
    } else {
      api.reload('4fde4a45', component.options)
    }
    module.hot.accept("./SucFileFieldComponent.vue?vue&type=template&id=4fde4a45&scoped=true&", function () {
      api.rerender('4fde4a45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/SucFileFieldComponent.vue"
export default component.exports